<template>
  <div>
    <h3 class="mb-4">SN Anomaly Report</h3>

    <div class="flex flex-wrap items-center justify-between mb-4">
      <p class="text-sm text-gray-600">
        Menampilkan Pack ID dari transaksi GR (product TVD) yang tidak sesuai pattern SN lazim.
      </p>
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-download"
        :disabled="anomalies.length === 0"
        @click="exportCsv"
      >
        Export CSV
      </vs-button>
    </div>

    <div v-if="isLoading" class="text-center py-8">
      Loading...
    </div>

    <div v-if="!isLoading && anomalies.length === 0" class="text-center py-8">
      Tidak ada SN anomali ditemukan. ({{ totalChecked }} Pack ID dicek)
    </div>

    <vs-table v-if="!isLoading && anomalies.length > 0" :data="paginatedData" class="sn-anomaly-tbl">
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>Pack ID</vs-th>
        <vs-th>Product Code</vs-th>
        <vs-th>GR Reference</vs-th>
        <vs-th>Base Qty</vs-th>
        <vs-th>Created At</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tr v-for="(row, index) in data" :key="index">
          <vs-td>{{ dataFrom + index }}</vs-td>
          <vs-td class="text-bold-red">{{ row.pack_id }}</vs-td>
          <vs-td>{{ row.product_code }}</vs-td>
          <vs-td>{{ row.gr_reference }}</vs-td>
          <vs-td>{{ row.base_qty }}</vs-td>
          <vs-td>{{ row.created_at }}</vs-td>
        </tr>
      </template>
    </vs-table>

    <div v-if="!isLoading && anomalies.length > 0" class="flex justify-end items-center mt-4">
      <p class="mr-4 mb-0">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ anomalies.length }} anomali</b>
        (dari {{ totalChecked }} total dicek)
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      isLoading: false,
      anomalies: [],
      totalChecked: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    totalPage() {
      return Math.ceil(this.anomalies.length / this.perPage);
    },
    dataFrom() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    dataTo() {
      return Math.min(this.currentPage * this.perPage, this.anomalies.length);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.anomalies.slice(start, start + this.perPage);
    },
  },
  mounted() {
    this.fetchReport();
  },
  methods: {
    fetchReport() {
      this.isLoading = true;
      this.$http
        .get("support/sn-anomaly-report")
        .then((res) => {
          this.anomalies = res.data.data || [];
          this.totalChecked = res.data.total_checked || 0;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("error", error);
        });
    },
    exportCsv() {
      this.isLoading = true;
      this.$http
        .get("support/sn-anomaly-report/export-csv", { responseType: "blob" })
        .then((response) => {
          var blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
          this.isLoading = false;
          saveAs(blob, `sn_anomaly_report_${Date.now()}.csv`);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("error", error);
        });
    },
  },
};
</script>

<style scoped>
.sn-anomaly-tbl .text-bold-red {
  color: #d63031;
  font-weight: 700;
}
</style>
